import { motion } from "framer-motion";
import { useLenis } from "lenis/react";
import { Compass } from "lucide-react";

export default function Navbar() {
  const lenis = useLenis();

  const scrollTo = (target) => {
    if (lenis) lenis.scrollTo(target, { offset: -20 });
  };

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 mix-blend-difference"
      data-testid="navbar"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-6 flex items-center justify-between text-white">
        <button
          onClick={() => scrollTo(0)}
          className="flex items-center gap-2 font-display font-extrabold tracking-tight text-lg"
          data-testid="nav-logo"
        >
          <Compass className="w-5 h-5" strokeWidth={2.5} />
          OSMAND<span className="font-serif-editorial italic font-normal lowercase">masterclass</span>
        </button>
        <nav className="hidden md:flex items-center gap-10 text-xs uppercase tracking-[0.2em] font-medium">
          <button onClick={() => scrollTo("#manifesto")} className="hover:opacity-60 transition-opacity" data-testid="nav-manifesto">Il Corso</button>
          <button onClick={() => scrollTo("#docente")} className="hover:opacity-60 transition-opacity" data-testid="nav-docente">Docente</button>
          <button onClick={() => scrollTo("#iscrizione")} className="hover:opacity-60 transition-opacity" data-testid="nav-signup">Iscriviti</button>
          <a href="https://www.offroaditalia.com" target="_blank" rel="noopener noreferrer" className="hover:opacity-60 transition-opacity" data-testid="nav-website">offroaditalia.com</a>
        </nav>
        <button
          onClick={() => scrollTo("#iscrizione")}
          className="text-xs uppercase tracking-[0.2em] font-semibold border border-white/60 rounded-full px-5 py-2 hover:bg-white hover:text-black transition-colors"
          data-testid="nav-cta"
        >
          Gratis →
        </button>
      </div>
    </motion.header>
  );
}
